<device-versions-query
  [isLoading]="isLoading"
  [total]="totalDevices"
  (query)="onQuery($event)"></device-versions-query>

<ag-grid-angular
  class="ag-theme-alpine ag-grid-sticky-header"
  domLayout="autoHeight"
  style="width: 100%; height: 100%"
  [columnDefs]="columnDefinitions"
  [defaultColDef]="defaultColumnConfiguration"
  [enableBrowserTooltips]="true"
  [enableCellTextSelection]="true"
  [ensureDomOrder]="true"
  [pagination]="false"
  [rowData]="apps"
  [rowSelection]="'single'"
  [suppressRowHoverHighlight]="true"></ag-grid-angular>

<dcc-spinner *ngIf="isLoading"></dcc-spinner>

<simple-paginator
  *ngIf="apps?.length"
  [pageCount]="pageCount"
  [pageNumber]="pageNumber"
  (clickFirst)="onClickFirst()"
  (clickNext)="onPaginate()"></simple-paginator>
